import { BookOpen } from 'lucide-react';
import { ChapterEditor } from './components/ChapterEditor';
import { useWorkspace } from './WorkspaceContext';
// 注意：chapterManager.css 由 web-entry → index.css 全局引入（见 src/index.css 的 @import）。
// 此处不要再重复 import —— Vite 的开发态不会对 CSS 去重，会把整份 barrel（16 个分片、
// 约 1000 条规则）在文档里注入两次；后一份在层叠上必然压过前一份，
// 于是前一份的全部规则都变成死声明，排查样式时会看到"同名规则两份、改一份不生效"。
// 该重复曾导致 .ai-act-feed 的 97 条声明整份失效。

export function Workspace() {
  const {
    selectedChapter,
    chapterContent,
    isChapterContentLoading,
    isExternalWriting,
    setEditorRef,
    setHasUnsavedChanges,
    handleOpenVersionHistory,
    handleSaveChapter,
    handleVersionSaved,
    handlePolishSelection,
    handleAddToAssistant,
  } = useWorkspace();

  return (
    <div className="cm-container">
      <div id="cm-toolbar-slot" className="cm-toolbar-slot" />
      <div className="cm-content-area">
        <div className="cm-content-left">
          <div className="cm-editor-area">
            {isChapterContentLoading ? (
              <div className="cm-editor-loading">
                <svg className="cm-editor-loading-spinner" width="40" height="40" viewBox="0 0 48 48" style={{ animation: 'spin 0.8s linear infinite', color: 'var(--primary-color)' }}>
                  <circle cx="24" cy="24" r="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeDasharray="94.2" strokeDashoffset="31.4" strokeLinecap="round" />
                </svg>
                <span className="cm-editor-loading-text">正在加载章节内容...</span>
              </div>
            ) : selectedChapter ? (
              <ChapterEditor
                key={selectedChapter.id}
                chapter={selectedChapter}
                content={chapterContent}
                onSave={handleSaveChapter}
                onEditorReady={setEditorRef}
                isExternalWriting={isExternalWriting}
                onPolishSelection={handlePolishSelection}
                onAddToAssistant={handleAddToAssistant}
                onOpenVersionHistory={handleOpenVersionHistory}
                onVersionSaved={handleVersionSaved}
                onUnsavedChange={setHasUnsavedChanges}
              />
            ) : (
              <div className="cm-empty-state">
                <BookOpen size={48} strokeWidth={1} className="empty-icon" />
                <h2 className="empty-title">选择一个章节开始创作</h2>
                {/* 此前这里写的是"新建分卷请前往「设定管理」"—— 把三步跳跃当成了引导。
                    现在新作品自带一个默认卷、侧栏顶部就有「新建章节」，不再需要这层指引。 */}
                <p className="empty-desc">从左侧目录选择章节开始创作；左侧「＋ 新建章节」可新增一章</p>
              </div>
            )}
          </div>
          <div id="cm-statusbar-slot" className="cm-statusbar-slot" />
        </div>
      </div>
    </div>
  );
}
